/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/prop-types */
import React, { useState, useRef, useEffect } from 'react'
import { Button, Carousel, Image } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function CarouselStickyPreview({
  srcs,
  isMediaVisible,
  setFullScreenShowMedia,
  redirectUrl,
}) {
  const [showCarousel, setShowCarousel] = useState(true)
  const [isMinimized, setIsMinimized] = useState(false)
  const containerRef = useRef(null)

  const handleCarouselClick = () => {
    if (isMinimized) {
      setIsMinimized(false)
    } else if (redirectUrl) {
      window.open(redirectUrl, '_blank')
    }
  }

  return (
    <div
      className="scroller-hide"
      ref={containerRef}
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '6%' }}
        />
      </div>
      <div style={{ position: 'relative' }}>
        <div
          className="border-bottom mb-3 d-flex"
          style={{ width: '240px', height: '55px', zIndex: '0' }}
        >
          <div className="w-80 m-auto ms-auto">
            <Image src={wavenet_logo} className="w-75 ps-3" />
          </div>
          <div className="w-20 m-auto ms-auto d-flex">
            <FontAwesomeIcon icon={faBars} className="text-end" />
          </div>
        </div>
        <div className="text-title" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-ban1" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line2" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>

      {showCarousel && (
        <>
          <Carousel
            className="mx-auto position-absolute"
            onClick={handleCarouselClick}
            interval={3000} // ✅ 自動輪播
            indicators={!isMinimized} // ✅ 縮小時隱藏 indicator
            style={{
              width: isMinimized ? '6.5rem' : '240px',
              height: isMinimized ? '13rem' : 'auto',
              top: isMinimized ? '50%' : '14%',
              left: isMinimized ? '60.5%' : 'auto',
              right: isMinimized ? 'auto' : '19%',
              transition:
                'width 0.3s ease-in-out, left 0.3s ease-in-out, height 0.3s ease-in-out',
              zIndex: '1501',
              cursor: isMinimized ? 'pointer' : 'default',
            }}
          >
            {srcs.length > 0 ? (
              srcs.map((src, idx) => (
                <Carousel.Item key={idx}>
                  <img
                    className="d-flex"
                    src={
                      src.file instanceof File || src.file instanceof Blob
                        ? URL.createObjectURL(src.file)
                        : src.file
                    }
                    alt={src.label}
                    style={{
                      objectFit: 'cover',
                      height: isMinimized ? '13rem' : '30rem',
                      borderRadius: isMinimized ? '10px' : '0px',
                    }}
                  />
                </Carousel.Item>
              ))
            ) : (
              <Carousel.Item>
                <div className="text-center p-3 text-muted">請上傳圖片</div>
              </Carousel.Item>
            )}
          </Carousel>
          <Button
            onClick={() => {
              if (isMinimized) {
                setShowCarousel(false)
              } else {
                setIsMinimized(true)
              }
            }}
            style={{
              position: 'absolute',
              top: isMinimized ? '48%' : '10.5%',
              left: isMinimized ? '69.5%' : 'auto',
              right: isMinimized ? 'auto' : '19.5%',
              background: 'rgba(0, 0, 0, 0.5)',
              color: 'white',
              border: 'none',
              borderRadius: '50%',
              width: isMinimized ? '12px' : '24px',
              height: isMinimized ? '12px' : '24px',
              fontSize: isMinimized ? '10px' : '14px',
              cursor: 'default',
              zIndex: '1501',
              padding: '0',
              transition: 'left 0.3s ease-in-out, right 0.3s ease-in-out',
            }}
          >
            ✕
          </Button>
        </>
      )}

      <div style={{ position: 'relative' }}>
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>
      <div
        style={{
          position: 'absolute',
          top: isMinimized ? 'calc(50% + 13rem - 1.8rem)' : 'auto',
          left: isMinimized ? 'calc(60.5% + 6.5rem)' : 'auto',
          bottom: isMinimized ? '15%' : '6%',
          right: isMinimized ? 'auto' : '19%',
          zIndex: '1502',
        }}
      >
        <CIIcon />
      </div>
    </div>
  )
}

export default CarouselStickyPreview
